(function (root) {
  'use strict';

  var ENDPOINT = '/apps/bb-portal/projects';
  var pendingByFingerprint = {};

  function text(value, maxLength) {
    return String(value == null ? '' : value)
      .replace(/[\u0000-\u001f\u007f]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, maxLength || 120);
  }

  function configurationObject(value) {
    var parsed = value;
    if (typeof value === 'string') {
      try { parsed = JSON.parse(value); } catch (error) { parsed = {}; }
    }
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return Object.keys(parsed).slice(0, 12).reduce(function (result, name) {
      var cleanName = text(name, 60);
      var cleanValue = text(parsed[name], 80);
      if (cleanName && cleanValue) result[cleanName] = cleanValue;
      return result;
    }, {});
  }

  function dateParts(value) {
    var date = new Date(value || Date.now());
    if (Number.isNaN(date.getTime())) date = new Date();
    var year = String(date.getFullYear());
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return {
      savedAt: date.toISOString(),
      savedOn: year + '-' + month + '-' + day
    };
  }

  function payload(input) {
    input = input || {};
    var date = dateParts(input.now);
    return {
      action: 'label',
      designId: text(input.designId, 160),
      productTitle: text(input.productTitle, 120),
      configuration: configurationObject(input.configuration),
      savedAt: date.savedAt,
      savedOn: date.savedOn
    };
  }

  function persist(input) {
    if (!root.zakekeCustomerId || !input || !text(input.designId, 160)) {
      return Promise.resolve(false);
    }
    var body = payload(input);
    var fingerprint = body.designId + '|' + JSON.stringify(body.configuration);
    if (pendingByFingerprint[fingerprint]) return pendingByFingerprint[fingerprint];
    pendingByFingerprint[fingerprint] = root.fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not label saved design');
      delete pendingByFingerprint[fingerprint];
      return true;
    }).catch(function (error) {
      delete pendingByFingerprint[fingerprint];
      console.warn('[BadgeBuzz] Saved-design label was not persisted.', error);
      return false;
    });
    return pendingByFingerprint[fingerprint];
  }

  root.BBSavedDesignLabels = {
    payload: payload,
    persist: persist
  };
})(typeof window !== 'undefined' ? window : globalThis);
